/**
 * Nomes que ninguem pode escolher como login no registo (F-009): o site usa
 * `growup.gg/<nickname>` como atalho para a pagina publica, e estes enderecos
 * sao (ou vao ser) paginas do site, prefixos tecnicos ou nomes que se
 * confundiriam com a Grow uP. Quem ja tem um destes logins continua com ele e
 * com a pagina em `/membros/<nickname>`; so nao tem o atalho.
 */
export const RESERVED_LOGINS: ReadonlySet<string> = new Set([
  // Paginas do site
  'arena',
  'conta',
  'contactos',
  'equipas',
  'eventos',
  'hall-of-fame',
  'loja',
  'membros',
  'memorial',
  'noticias',
  'parceiros',
  'partners',
  'passatempos',
  'premios',
  'privacidade',
  'sobre',
  'socios',
  'streamers',
  'termos',
  // Paginas que podem vir a existir
  'ajuda',
  'blog',
  'calendario',
  'carrinho',
  'checkout',
  'definicoes',
  'entrar',
  'jogos',
  'login',
  'perfil',
  'pesquisa',
  'registar',
  'registo',
  'suporte',
  'torneios',
  // Prefixos e subdominios tecnicos
  'admin',
  'api',
  'assets',
  'favicon',
  'gestao',
  'mail',
  'media',
  'robots',
  'sitemap',
  'static',
  'staging',
  'status',
  'streaming',
  'www',
  // A propria Grow uP
  'grow-up',
  'growup',
  'growupgaming',
  'growup.gg',
  'staff',
]);

export function isReservedLogin(login: string): boolean {
  return RESERVED_LOGINS.has(login.trim().toLowerCase());
}
